// extracted by mini-css-extract-plugin
module.exports = {"Container":"inspected-brand_Container__vyYh0"};